
import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyAdQP4xna-SOBoW7fpL4mh8RDm9QyjmkqE",
  authDomain: "dubs-go-green.firebaseapp.com",
  projectId: "dubs-go-green",
  storageBucket: "dubs-go-green.appspot.com",
  messagingSenderId: "17043376972",
  appId: "1:17043376972:web:5322f33e2150b621e8dde9",
  measurementId: "G-MTVJ46D4G5"
};

const app = initializeApp(firebaseConfig);